var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.loading
      ? _c(
          "div",
          { staticClass: "row justify-center q-my-md" },
          [_c("q-spinner-dots", { attrs: { color: "primary", size: "3em" } })],
          1
        )
      : _c(
          "div",
          [
            _c("div", { staticClass: "row justify-between q-col-gutter-sm" }, [
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c("q-btn", {
                    attrs: {
                      label: _vm.$t("button.addAllPalletLogsToWatchlist"),
                      color: "primary"
                    },
                    on: {
                      click: function($event) {
                        _vm.showAddAllToWatchlistDialog = true
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col col-shrink" },
                [
                  _c("search-view-select", {
                    attrs: { palletLogSearch: "" },
                    on: { input: _vm.setSearchDisplayType }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm.palletLogSearchDisplayType === "teaser"
              ? [
                  _c(
                    "div",
                    { staticClass: "row q-py-lg q-col-gutter-md" },
                    _vm._l(_vm.palletLogs, function(object) {
                      return _c(
                        "div",
                        {
                          key: object.uid,
                          staticClass:
                            "col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3"
                        },
                        [
                          _c("veneer-log", {
                            attrs: {
                              "emit-log": true,
                              log: object,
                              "watchlist-dialog": true,
                              "measurement-list-dialog": true,
                              "show-active-watchlist-check": true,
                              "is-dynamic-watchlist": false,
                              "is-public": false
                            },
                            on: {
                              click: function($event) {
                                return _vm.showLogDetailDialog(object)
                              }
                            }
                          })
                        ],
                        1
                      )
                    }),
                    0
                  )
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.palletLogSearchDisplayType === "table"
              ? [
                  _c(
                    "div",
                    { staticClass: "q-py-lg justify-center" },
                    [
                      _c("veneer-log-table", {
                        attrs: { logs: _vm.palletLogs, "emit-log": true },
                        on: { click: _vm.showLogDetailDialog }
                      })
                    ],
                    1
                  )
                ]
              : _vm._e(),
            _vm._v(" "),
            _c(
              "q-dialog",
              {
                attrs: { square: "" },
                model: {
                  value: _vm.showAddAllToWatchlistDialog,
                  callback: function($$v) {
                    _vm.showAddAllToWatchlistDialog = $$v
                  },
                  expression: "showAddAllToWatchlistDialog"
                }
              },
              [
                _c(
                  "q-card",
                  [
                    _c("dialog-header", {
                      attrs: { "dialog-title": "watchPallet" },
                      on: {
                        close: function($event) {
                          _vm.showAddAllToWatchlistDialog = false
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("q-card-section", [
                      _c("div", { staticClass: "column" }, [
                        _vm.user.zohoAuthenticated
                          ? _c(
                              "div",
                              { staticClass: "col" },
                              [
                                _c("customer-select", {
                                  attrs: {
                                    "customer-name": _vm.presetCustomerName
                                  },
                                  model: {
                                    value: _vm.selectedCustomer,
                                    callback: function($$v) {
                                      _vm.selectedCustomer = $$v
                                    },
                                    expression: "selectedCustomer"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("watchlist-select", {
                              attrs: {
                                "watchlist-name": _vm.presetWatchlistName,
                                customer: _vm.selectedCustomer,
                                disable:
                                  _vm.user.zohoAuthenticated &&
                                  !_vm.selectedCustomer,
                                "only-static": ""
                              },
                              model: {
                                value: _vm.selectedWatchlist,
                                callback: function($$v) {
                                  _vm.selectedWatchlist = $$v
                                },
                                expression: "selectedWatchlist"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("q-input", {
                              attrs: {
                                type: "number",
                                prefix: _vm.$t("label.price"),
                                suffix: _vm.priceUnit,
                                "input-class": "text-right"
                              },
                              model: {
                                value: _vm.newPrice,
                                callback: function($$v) {
                                  _vm.newPrice = $$v
                                },
                                expression: "newPrice"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("q-input", {
                              attrs: {
                                placeholder: _vm.$t("addDescription"),
                                disabled: _vm.saving,
                                label: _vm.$t("label.comment"),
                                autogrow: ""
                              },
                              model: {
                                value: _vm.newDescription,
                                callback: function($$v) {
                                  _vm.newDescription = $$v
                                },
                                expression: "newDescription"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row q-mt-md justify-end" }, [
                        _c(
                          "div",
                          [
                            _c("q-btn", {
                              attrs: {
                                label: _vm.$t("button.cancel"),
                                flat: ""
                              },
                              on: {
                                click: function($event) {
                                  _vm.showAddAllToWatchlistDialog = false
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c("q-btn", {
                              attrs: {
                                label: _vm.$t("button.watch"),
                                loading: _vm.saving,
                                color: "primary",
                                disable: _vm.disableSave
                              },
                              on: { click: _vm.addAllPalletLogsToWatchlist }
                            })
                          ],
                          1
                        )
                      ])
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "q-dialog",
              {
                attrs: { "full-width": true, square: "" },
                model: {
                  value: _vm.logDetailDialogVisible,
                  callback: function($$v) {
                    _vm.logDetailDialogVisible = $$v
                  },
                  expression: "logDetailDialogVisible"
                }
              },
              [
                _c(
                  "q-card",
                  [
                    _c("dialog-header", {
                      attrs: { "dialog-title": "", "raw-title": true },
                      on: {
                        close: function($event) {
                          _vm.logDetailDialogVisible = false
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "q-card-section",
                      [
                        _c("detail", {
                          attrs: {
                            "prop-log": _vm.detailLog,
                            "hide-back-link": true
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          2
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }